import { Button, Table, TableBulkActionsBarProps } from "@oysterhr/ui"

import { useIntegratedTableController } from "./IntegratedTableControllerContext"
import { TableSelectionController } from "~/shared/components/IntegratedTable/useTableSelectedEntries"
import { ReactNode } from "react"

export type BulkActionButtonsArgs = TableSelectionController
export type IntegratedTableBulkActionsBarProps = Omit<
  TableBulkActionsBarProps,
  "clearSelectionButton" | "numberOfSelectedRecords" | "onSelectOption" | "primaryActionButton"
> & {
  renderBulkActionButtons: (args: BulkActionButtonsArgs) => ReactNode
}

export const IntegratedTableBulkActionsBar = ({
  renderBulkActionButtons,
  ...props
}: IntegratedTableBulkActionsBarProps) => {
  const { resetSelection, selectedEntriesCount, onChangeMultiSelectionState } =
    useIntegratedTableController()
  return (
    <Table.BulkActionsBar
      onSelectOption={onChangeMultiSelectionState}
      clearSelectionButton={
        <Button type="button" onClick={resetSelection}>
          Clear selection
        </Button>
      }
      numberOfSelectedRecords={selectedEntriesCount}
      primaryActionButton={<div>{renderBulkActionButtons(useIntegratedTableController())}</div>}
      {...props}
    />
  )
}

IntegratedTableBulkActionsBar.displayName = "IntegratedTable.BulkActionsBar"
